import {getKefu} from "../api/app";
import config from "../config.js";
import tip from '@/assets/tip.mp3';
import online from '@/assets/online.mp3';
import Event from './event.js';
import request from '@/plugins/axios'
import Timers from './timer.js';
import { Message } from 'element-ui'


class net {
    tipVoice = false; //消息声音提醒
    tipMsgTime= 15000; //未读发送短信时间
    MsgTip = false;
    userInfo = {};//用户信息存储
    socket = {on:this.on.bind(this),off:this.off.bind(this),emit:this.emit.bind(this)};
    //断线重连属性
    reconnectAttempts = 0;
    maxReconnectAttempts = 9999;
    reconnectDelay = 3000;
    reconnectTimer = null;
    async init(){
        let userData  = await getKefu();
        this.userInfo = {
            "user_id":userData.admin_id,//ID
            "dept_id":userData.dept_id[0],
            "avatar": userData.avatar,
            "nickname": userData.name,
            "dept_name":userData.dept_name,
            "token": userData.token,
            "user_type":"kefu",
            "game_ids": userData.game_ids//游戏
        }
        this.reconnectAttempts = 0; // 初始化重连次数
        this.connectWebSocket();
    }

    connectWebSocket() {
        const ws = new WebSocket(config.wsURL + '?user_type=kefu&token=' + this.userInfo.token);
        this.ws = ws;
        this.ws.onopen = this.connected.bind(this);
        this.ws.onclose = this.disconnected.bind(this);
        this.ws.onerror = (error) => {
        }
        this.ws.onmessage = (msg) => {
            const msgData = JSON.parse(msg.data);
            console.log("收到服务端消息", msgData);
            Event.$emit(msgData.type, msgData.msg);
        };
        this.socket.close = () => {
            Event.$off('message')//收到消息
            Event.$off('threadUpdate');//会话更新
            Event.$off('offlineUser');//监听用户下线
            Event.$off('online');//获取所有在线用户
            Event.$off("read");//已读回执
            Event.$off("onSentMessage");
            Event.$off("onlineUser");//用户上线
            Event.$off("offlineUser");//用户上线
            Event.$off("read");//已读回执
            Event.$off("recall");//撤回回执
            Event.$off("errorMessage");//服务器发给我们的错误信息
            this.ws.close();
        };
    }

    emit(type, msg={}) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify({type: type, msg: msg}));
        } else {
            console.error('WebSocket连接未打开，无法发送消息');
        }
    }

    //建立连接成功
    connected(){
        this.reconnectAttempts = 0;
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }
        Event.$emit("connected",this.userInfo);
        Event.$on("onSentMessage",this.onSent.bind(this));//发送消息回执
        Event.$on("onlineUser",this.onlineUser.bind(this));//获取所有用户在线
        Event.$on("read",this.onRead.bind(this));//服务器发给我们的已读回执
        Event.$on("errorMessage",this.onErrorMessage.bind(this));//服务器发给我们的已读回执
    }

    //断开连接
    disconnected(){
        Event.$off('message')//收到消息
        Event.$off('threadUpdate');//会话更新
        Event.$off('onlineUser');//监听用户下线
        Event.$off('offlineUser');//监听用户下线
        Event.$off('online');//获取所有在线用户
        Event.$off("read");//已读回执
        Event.$off("onSentMessage");
        Event.$off("read");//已读回执
        Event.$off("recall");//撤回回执
        Event.$off("errorMessage");//服务器发给我们的错误信息
        Event.$emit("disconnected",this.userInfo);
        this.tryReconnect();
    }

    //断线重连
    tryReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            console.log(`尝试重连，第${this.reconnectAttempts}次`);
            this.reconnectTimer = setTimeout(() => {
                this.connectWebSocket();
            }, this.reconnectDelay);
        } else {
            console.error("重连次数已达上限，停止重连");
        }
    }


    onErrorMessage(msg) {
        Message.error(msg.msg);
    }

    on(type, callback) {
        Event.$on(type, callback.bind(this));
    }

    off(type, callback) {
        Event.$off(type, callback.bind(this));
    }

    //标记已读
    upRead(msg){
        this.socket.emit("read",msg);
    }

    //撤回消息
    recall(msg){
        this.socket.emit("recall",msg);
    }


    //获取在线用户
    onlineUsers(){
        if(this.ws) this.socket.emit("online");
    }

    //组装发送数据
    buildMsg(to,content,type="private",content_type=1,thread_id=null){
        let type_map = {1:"text",2:"image",3:"link"};
        let datas = {
            from:"kefu_"+this.userInfo.user_id,
            to:to,
            msg_type:type,//private私聊 group群聊
            type:content_type,//1~8 1文字 2图片 3链接  7系统提示 8卡片
            fromData:{
                user_type:this.userInfo.user_type,
                avatar: this.userInfo.avatar,
                nickname: this.userInfo.nickname
            },
            payload:{
                type:type_map[content_type],
                txt:content,
                thread_id:thread_id
            }
        }
        return datas;
    }

    sendMsg(msg){
        this.socket.emit("message",msg);
    }

    //消息发送成功回执
    async onSent(msg){
        await this.saveMsg(msg);
        this.socket.emit('sendMessage',msg);
    }

    onRead(msg){ }

    async onlineUser(msg) {
        console.log("用户上线了");
        if(this.tipVoice){
            const audio = new Audio(online);
            audio.play().catch(e => {
                console.log("播放失败", e);
            });
        }
    }

    async onMsg(msg) {
        try {
            const data = JSON.parse(msg);
            if(this.tipVoice){
                const audio = new Audio(tip);
                audio.play().catch(e => {
                    console.log("播放失败", e);
                });
            }
            Event.$emit("message", data);
            //未读消息发送短信
            if (this.tipMsgTime > 0 && data.msg_type === 'private' && data.to === this.userInfo.user_id) {
                if (this.MsgTip === false) {
                    this.MsgTip = true;
                    Timers.set("MsgTip", () => {
                        this.MsgTip = false;
                    }, this.tipMsgTime);
                    await request.post('/tenantapi/kefu.kefu/sendMsgTip', {
                        from: data.fromData?.nickname || '用户',
                        to: this.userInfo.nickname,
                        avatar: data.fromData?.avatar || '',
                        content: data.payload?.txt || ''
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    async saveMsg(msg){
        //信息存储到服务端
        let msg_datas = {
            type:msg.msg_type,
            user_id:msg.msg_type=="private"?msg.to.replace("user_",""):null,
            group_id:msg.msg_type=="private"?null:msg.to.replace("group_",""),
            content:msg,
            msg_sn:msg.timestamp,
            messageId:msg.messageId//GoeasyMessageId
        }
        let m = await request.post("/tenantapi/kefu.kefu/send",msg_datas);
        //未读短信提醒
        if(msg.msg_type==='group') return;//群消息未读不发送
        let to = msg.to.replace("user_","");
        //清空消息时钟短信提醒
        if(this.MsgTip === false) return;
        if(Timers.msgTipTimer[to]) clearTimeout(Timers.msgTipTimer[to]);//防止消息重复发送
        //15s后发送消息
        Timers.msgTipTimer[to] = setTimeout(()=>{
            request.post("/tenantapi/kefu.kefu/sendMsgTip",{user_id:to,scene:"MSGTIP"}).then((res)=>{
            });
        }, this.tipMsgTime);

    }

}

export default new net();